import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { HamburgerTab } from '../../constants/Enums';
import { UIHelper } from '../../utils/UIHelper';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';

export interface BaseHamburgerTabProps {
    userLanguage: string;
    layoutType: LayoutType;
    sidebarOrientation: string;
    position: number;
}

export abstract class BaseHamburgerTab<T1> extends BaseComponent<BaseHamburgerTabProps, T1> {
    protected previous: HamburgerTab | null = null;

    public componentDidUpdate(): void {
        UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
    }

    public componentDidMount(): void {
        UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
    }

    protected abstract getLabel(): string;

    protected back = (): void => {
        if (
            (this.previous !== null) ||
            (this.props.layoutType === LayoutType.SMALL) ||
            (AppConfigurationStore.getState().inApp && AppConfigurationStore.getState().singleHamburgerTabs)
        ) {
            ViewSettingsActions.changeHamburger(this.previous);
        }
    };

    protected getCSSClass = (): string => {
        if (!this.props.position) {
            return 'hamburger-tab';
        }
        switch (this.props.position) {
            case -1:
                return 'hamburger-tab';
            case 1:
                return 'hamburger-tab second-hamburger-tab';
            case 2:
                return 'hamburger-tab third-hamburger-tab';
            default:
                break;
        }
        return 'hamburger-tab';
    };

    protected popupClass = (noArrow?: boolean): string => {
        let popupClass: string = 'hamburger-header';
        if (
            !noArrow &&
            (
                (this.previous !== null) ||
                (this.props.layoutType === LayoutType.SMALL) ||
                (AppConfigurationStore.getState().inApp && AppConfigurationStore.getState().singleHamburgerTabs)
            )
        ) {
            popupClass += ' hamburger-header-with-arrow';
        }
        if (this.props.sidebarOrientation === 'right') {
            popupClass += ' hamburger-header-right';
        }
        return popupClass;
    };

    protected header = (noArrow?: boolean): JSX.Element => {
        if (!AppConfigurationStore.getState().inApp) {
            return (
                <div className="hamburger-tab-header" onClick={this.back}>{this.getLabel()}</div>
            );
        }
        return (
            <div className={this.popupClass(noArrow)} onClick={this.back}>
                <div className="hamburger-header-label">{this.getLabel()}</div>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/BaseHamburgerTab.tsx